// Version : 1.0.0
// Author : AGALYA
import { takeLatest, put, all, call } from 'redux-saga/effects';
import CoApplicantActionType from './co-applicant.types';
import {
	updateCoApplicantSuccess,
	updateCoApplicantFailure,
	updateCoApplicantResponseChanged,
	addCoBorrowerResponseChanged,
	addCoBorrowerSuccess,
	addCoBorrowerFailure,
	fetchCoBorrowerResponseChanged,
	fetchCoBorrowerFailure,
	fetchCoBorrowerSuccess,
	deleteCoBorrowerResponseChanged,
	deleteCoBorrowerSuccess,
	deleteCoBorrowerFailure,
	checkCoBorrowerHighMarkSuccess,
	checkCoBorrowerHighMarkFailure,
	checkCoBorrowerHighMarkRespChanged,
	verifyCoApplicantAadharOtpResponseChanged,
	verifyCoApplicantAadharOtpFailure,
	verifyCoApplicantAadharOtpSuccess,
	verifyValidateCoApplicantAadharOtpResponseChanged,
	verifyValidateCoApplicantAadharOtpFailure,
	verifyValidateCoApplicantAadharOtpSuccess,
} from './co-applicant.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	coApplicantAdd,
	coApplicantCrifAPI,
	coApplicantDelete,
	coApplicantFetch,
	coApplicantUpdate,
	verifyCoApplicantAadharOtpAPI,
	verifyValidateCoApplicantAadharOtpAPI,
} from './co-applicant.service';

/** ***************** UPDATE CO-APPLICANT START *********************** */
export function* updateCoApplicantIdDetails({ payload }: any) {
	try {
		const key = 'updateCoApplicantID';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			MemberID: payload.memberID,
			UserID: payload.userID,
			CoApplicantDetailsArr: payload.coApplicantsDetailsArr,
			Secratekey: key,
		};
		const coApplicantData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(coApplicantUpdate, coApplicantData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateCoApplicantFailure(responseData.data));
		} else {
			yield put(updateCoApplicantSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateCoApplicantFailure(error));
	}
}

export function* updateCoApplicantResponseClear() {
	yield put(updateCoApplicantResponseChanged());
}

export function* onCoApplicantUpdateStart() {
	yield takeLatest(CoApplicantActionType.UPDATE_CO_APPLICANT_START, updateCoApplicantIdDetails);
}

export function* onCoApplicantUpdateResponseRest() {
	yield takeLatest(
		CoApplicantActionType.UPDATE_CO_APPLICANT_RESPONSE_REST_START,
		updateCoApplicantResponseClear,
	);
}
/** ***************** UPDATE CO-APPLICANT END *********************** */

/** ***************** ADD CO-APPLICANT START *********************** */
export function* addCoBorrowerDetails({ payload }: any) {
	try {
		const key = 'updateCoApplicantID';
		const {
			companyID,
			databaseName,
			memberID,
			userID,
			coApplicantAadharNumber,
			coApplicantAddressProof,
			coApplicantAddressProofNumber,
			coApplicantDOB,
			coApplicantIDProof,
			coApplicantIDProofNumber,
			coApplicantMonthlyIncome,
			coApplicantName,
			coApplicantOccupationSelectValue,
			coApplicantPhoneNumber,
			coApplicantProfileImg,
			coApplicantRelationship,
			coApplicantFrontAadhar,
			coApplicantBackAadhar,
			coApplicantFrontID,
			coApplicantBackID,
			coApplicantFrontAddress,
			coApplicantBackAddress,
			coAppSignatureImg,
			doorNo,
			addressStreet,
			country,
			state,
			district,
			city,
			pincode,
			coApplicantPostOffice,
			memberGender,
			maritalStatus,
			appliedAmount,
			relationshipwithMember,
			coApplicantID,
			coIsAadharVerified,
			coapplicantTogetherImg,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			UserID: userID,
			CoApplicantAadharNumber: coApplicantAadharNumber,
			CoApplicantAddressProof: coApplicantAddressProof,
			CoApplicantAddressProofNumber: coApplicantAddressProofNumber,
			CoApplicantDOB: coApplicantDOB,
			CoApplicantIDProof: coApplicantIDProof,
			CoApplicantIDProofNumber: coApplicantIDProofNumber,
			CoApplicantMonthlyIncome: coApplicantMonthlyIncome,
			CoApplicantName: coApplicantName,
			CoApplicantOccupationSelectValue: coApplicantOccupationSelectValue,
			CoApplicantPhoneNumber: coApplicantPhoneNumber,
			CoApplicantProfileImg: coApplicantProfileImg,
			CoApplicantRelationship: coApplicantRelationship,
			CoApplicantFrontAadhar: coApplicantFrontAadhar,
			CoApplicantBackAadhar: coApplicantBackAadhar,
			CoApplicantFrontID: coApplicantFrontID,
			CoApplicantBackID: coApplicantBackID,
			CoApplicantFrontAddress: coApplicantFrontAddress,
			CoApplicantBackAddress: coApplicantBackAddress,
			CoAppSignatureImg: coAppSignatureImg,
			DoorNo: doorNo,
			AddressStreet: addressStreet,
			Country: country,
			State: state,
			District: district,
			City: city,
			Pincode: pincode,
			PostOffice: coApplicantPostOffice,
			CoApplicantGender: memberGender,
			MaritalStatus: maritalStatus,
			AppliedAmount: appliedAmount,
			CoApplicantRelationshipWithMember: relationshipwithMember,
			CoApplicantID: coApplicantID,
			Secratekey: key,
			CoIsAadharVerified: coIsAadharVerified,
			CoapplicantTogetherImg: coapplicantTogetherImg,
		};

		const coApplicantData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(coApplicantAdd, coApplicantData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addCoBorrowerFailure(responseData.data));
		} else {
			yield put(addCoBorrowerSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addCoBorrowerFailure(error));
	}
}

export function* addCoApplicantResponseClear() {
	yield put(addCoBorrowerResponseChanged());
}

export function* onCoApplicantAddStart() {
	yield takeLatest(CoApplicantActionType.ADD_COBORROWER_START, addCoBorrowerDetails);
}

export function* onCoApplicantAddResponseRest() {
	yield takeLatest(
		CoApplicantActionType.ADD_COBORROWER_RESPONSE_RESET_START,
		addCoApplicantResponseClear,
	);
}
/** ***************** ADD CO-APPLICANT END *********************** */

/** ***************** FETCH CO-APPLICANT START *********************** */
export function* fetchCoApplicantIdDetails({ payload }: any) {
	try {
		const key = 'FetchMemberDataKey';

		const { companyID, databaseName, coApplicantID } = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			CoApplicantID: coApplicantID,
			Secratekey: key,
		};

		const coApplicantData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(coApplicantFetch, coApplicantData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchCoBorrowerFailure(responseData.data));
		} else {
			yield put(fetchCoBorrowerSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchCoBorrowerFailure(error));
	}
}

export function* fetchCoApplicantResponseClear() {
	yield put(fetchCoBorrowerResponseChanged());
}

export function* onCoApplicantFetchStart() {
	yield takeLatest(CoApplicantActionType.FETCH_COBORROWER_START, fetchCoApplicantIdDetails);
}

export function* onCoApplicantFetchResponseRest() {
	yield takeLatest(
		CoApplicantActionType.FETCH_COBORROWER_RESPONSE_RESET_START,
		fetchCoApplicantResponseClear,
	);
}
/** ***************** FETCH CO-APPLICANT END *********************** */

/** ***************** DELETE CO-APPLICANT START *********************** */
export function* deleteCoApplicantDetails({ payload }: any) {
	try {
		const key = 'DeleteCoBorrowerKey';
		const { coApplicantID, databaseName, coApplicantMemberID } = payload;

		const jsonData = {
			CoApplicantID: coApplicantID,
			DatabaseName: databaseName,
			MemberID: coApplicantMemberID,
			Secratekey: key,
		};
		const coApplicantData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(coApplicantDelete, coApplicantData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteCoBorrowerFailure(responseData.data));
		} else {
			yield put(deleteCoBorrowerSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteCoBorrowerFailure(error));
	}
}

export function* deleteCoApplicantResponseClear() {
	yield put(deleteCoBorrowerResponseChanged());
}

export function* onCoApplicantDeleteStart() {
	yield takeLatest(CoApplicantActionType.DELETE_CO_APPLICANT_START, deleteCoApplicantDetails);
}

export function* onCoApplicantDeleteResponseRest() {
	yield takeLatest(
		CoApplicantActionType.DELETE_CO_APPLICANT_RESPONSE_REST_START,
		deleteCoApplicantResponseClear,
	);
}
/** ***************** DELETE CO-APPLICANT END *********************** */

/** ***************** CHECK CO-APPLICANT CRIF START *********************** */
export function* checkCoApplicantCrif({ payload }: any) {
	try {
		const key = 'CoBorrowerCrifCheckKey';

		const {
			coApplicantID,
			databaseName,
			coApplicantMemberID,
			userID,
			companyID,
			IsConsumer,
			coApplicantLoanAppliedAmount,
			generalCompanyID,
		} = payload;

		const jsonData = {
			CoApplicantID: coApplicantID,
			DatabaseName: databaseName,
			MemberID: coApplicantMemberID,
			User: userID,
			CompanyID: companyID,
			IsConsumer: IsConsumer,
			AppliedAmount: coApplicantLoanAppliedAmount,
			GeneralCompanyID: generalCompanyID,
			Secratekey: key,
		};

		const coApplicantData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(coApplicantCrifAPI, coApplicantData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkCoBorrowerHighMarkFailure(responseData.data));
		} else {
			yield put(checkCoBorrowerHighMarkSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkCoBorrowerHighMarkFailure(error));
	}
}

export function* CoApplicantCrifResponseClear() {
	yield put(checkCoBorrowerHighMarkRespChanged());
}

export function* onCoApplicantCrifStart() {
	yield takeLatest(CoApplicantActionType.CHECK_COBORROWER_HIGHMARK_START, checkCoApplicantCrif);
}

export function* onCoApplicantCrifResponseRest() {
	yield takeLatest(
		CoApplicantActionType.CHECK_COBORROWER_HIGHMARK_RESPONSE_RESET_START,
		CoApplicantCrifResponseClear,
	);
}
/** ***************** CHECK CO-APPLICANT CRIF END *********************** */

/** ***************** VERIFY CO-APPLICANT AADHAR OTP START *********************** */
export function* toVerifyCoApplicantAadharOtp({ payload }: any) {
	try {
		const key = 'AppVerifyKYCKey';

		const {
			companyID,
			userID,
			databaseName,
			memberID,
			generalCompanyID,
			memberCredential,
			type,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
			MemberID: memberID,
			GeneralCompanyID: generalCompanyID,
			MemberCredential: memberCredential,
			Type: type,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			verifyCoApplicantAadharOtpAPI,
			verifyData,
			payload.serviceName,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(verifyCoApplicantAadharOtpFailure(responseData.data));
		} else {
			yield put(verifyCoApplicantAadharOtpSuccess(responseData.data));
		}
	} catch (error) {
		yield put(verifyCoApplicantAadharOtpFailure(error));
	}
}

export function* VerifyCoApplicantAadharOtpResponseClear() {
	yield put(verifyCoApplicantAadharOtpResponseChanged());
}

export function* onVerifyCoApplicantAadharOtpStart() {
	yield takeLatest(
		CoApplicantActionType.VERIFY_CO_APPLICANT_AADHAR_OTP_START,
		toVerifyCoApplicantAadharOtp,
	);
}

export function* onVerifyCoApplicantAadharOtpRest() {
	yield takeLatest(
		CoApplicantActionType.VERIFY_CO_APPLICANT_AADHAR_OTP_RESPONSE_RESET_START,
		VerifyCoApplicantAadharOtpResponseClear,
	);
}
/** ***************** VERIFY CO-APPLICANT AADHAR OTP END *********************** */

/** ***************** VERIFY AND VALIDATE CO-APPLICANT AADHAR OTP START *********************** */
export function* toVerifyValidateCoApplicantAadharOtp({ payload }: any) {
	try {
		const key = 'AppVerifyKYCKey';

		const { companyID, userID, databaseName, memberID, generalCompanyID, randNum, otp, type } =
			payload;

		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
			MemberID: memberID,
			GeneralCompanyID: generalCompanyID,
			RandNum: randNum,
			Otp: otp,
			Type: type,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			verifyValidateCoApplicantAadharOtpAPI,
			verifyData,
			payload.serviceName,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(verifyValidateCoApplicantAadharOtpFailure(responseData.data));
		} else {
			yield put(verifyValidateCoApplicantAadharOtpSuccess(responseData.data));
		}
	} catch (error) {
		yield put(verifyValidateCoApplicantAadharOtpFailure(error));
	}
}

export function* VerifyValidateCoApplicantAadharOtpResponseClear() {
	yield put(verifyValidateCoApplicantAadharOtpResponseChanged());
}

export function* onVerifyValidateCoApplicantAadharOtpStart() {
	yield takeLatest(
		CoApplicantActionType.VERIFY_VALIDATE_CO_APPLICANT_AADHAR_OTP_START,
		toVerifyValidateCoApplicantAadharOtp,
	);
}

export function* onVerifyValidateCoApplicantAadharOtpRest() {
	yield takeLatest(
		CoApplicantActionType.VERIFY_VALIDATE_CO_APPLICANT_AADHAR_OTP_RESPONSE_RESET_START,
		VerifyValidateCoApplicantAadharOtpResponseClear,
	);
}
/** ***************** VERIFY AND VALIDATE CO-APPLICANT AADHAR OTP END *********************** */

export function* coApplicantSaga() {
	yield all([
		call(onCoApplicantUpdateStart),
		call(onCoApplicantUpdateResponseRest),
		call(onCoApplicantAddStart),
		call(onCoApplicantAddResponseRest),
		call(onCoApplicantFetchStart),
		call(onCoApplicantFetchResponseRest),
		call(onCoApplicantDeleteStart),
		call(onCoApplicantDeleteResponseRest),
		call(onCoApplicantCrifStart),
		call(onCoApplicantCrifResponseRest),
		call(onVerifyCoApplicantAadharOtpStart),
		call(onVerifyCoApplicantAadharOtpRest),
		call(onVerifyValidateCoApplicantAadharOtpStart),
		call(onVerifyValidateCoApplicantAadharOtpRest),
	]);
}
